var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"imgBox"}},[_c('img',{attrs:{"src":require("../assets/img/ABUIABAEGAAg5oGL9AUox9PE2wUw8Ac4zQY.png"),"alt":""}})])}]

export { render, staticRenderFns }